var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.hasRight)?_c('router-link',{staticClass:"router-link",attrs:{"title":_vm.$attrs.title,"to":_setup.to}},[_vm._t("default")],2):(_vm.visibleIfNoRight)?_c('span',[_vm._t("default")],2):_c('span')
}
var staticRenderFns = []

export { render, staticRenderFns }